// extracted by mini-css-extract-plugin
export default {"input":"UniversalSearchForm_input__l7o0o","inputNotEmpty":"UniversalSearchForm_inputNotEmpty__Ri83n"};